module.exports = require("file-loader");